import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';

export function getIsOriginalOpen(state: any, deviationId: number): boolean {
  const deviation = getDeviationById(state, deviationId);
  // Default to open if isOpen is not explicitly false
  return (deviation?.originals as any)?.isOpen !== false;
}
